/**
 * Utility functions for constructing profile picture URLs
 */

/**
 * Returns the S3 URL for a driver profile picture
 * The backend now returns the direct S3 URL, so we just use it as-is
 * 
 * @param {string} driverId - The driver's UUID (optional, for fallback)
 * @param {string} backendUrl - The S3 URL from the backend profile_photo field
 * @returns {string|null} The S3 URL or null if not provided
 */
export const getDriverProfilePictureUrl = (driverId, backendUrl = null) => {
  // Priority 1: Use the S3 URL provided by the backend
  if (backendUrl && (backendUrl.startsWith('http://') || backendUrl.startsWith('https://'))) {
    // This is a direct S3 URL, use it as-is
    return backendUrl;
  }

  // Priority 2: If backendUrl is a relative path, it might be a local file path
  // In this case, we can't construct a valid URL without more information
  if (backendUrl && backendUrl.startsWith('/')) {
    // This might be a local media path, but we expect S3 URLs from the backend
    console.warn('Received relative URL for profile picture, expected S3 URL:', backendUrl);
    return null;
  }

  // Priority 3: Fallback - if no URL provided but we have driverId, we can't construct S3 URL
  // because we don't know the exact file path/name in S3
  if (driverId && !backendUrl) {
    console.warn('No profile picture URL provided for driver:', driverId);
    return null;
  }

  // Return null if no valid URL can be constructed
  return null;
};

